import axios from "../api";
const queryParamDict = {
    countries: "country",
    leagues: "league",
    clubs: "club",
    skillMoves: "skill-moves",
    weakFoot: "weak-foot",
    positions: "position",
    rarities: "rarity",
    maxPlayStylesMax: "maxPlayStyles",
    maxPlayStylesPlusMax: "maxPlayStylesPlus",
};
export const getPlayers = async ({ page, sort, myClub, myEvolvedPlayers, activeSquad, chainedEvo, excludePaidEvo, excludeCompletedEvolutions, playerRoleId, playerRoleIds, queryParams, evolutions, evoIds, mustIncludeEvoIds, searchText, priceMin, priceMax, ratingMin, ratingMax, pastAndPresentClubs, countries, clubs, leagues, rarities, skillMoves, weakFoot, preferredFoot, heightMin, heightMax, playStyles, playStylesPlus, bodyTypes, gender, positions, inGameAttributes, }) => {
    const params = [];
    // Add page parameter
    params.push(`page=${page}`);
    // Add sort parameter without value
    params.push(`sort-${sort}`);
    // Add boolean parameters without values
    if (myClub)
        params.push("my-club");
    if (myEvolvedPlayers)
        params.push("my-evolved");
    if (activeSquad)
        params.push("active-squad");
    if (chainedEvo)
        params.push("chained");
    if (excludePaidEvo)
        params.push("excludePaid");
    if (excludeCompletedEvolutions)
        params.push("excludeCompleted");
    // Add parameters with values
    if (playerRoleIds?.length) {
        params.push(`player-role-ids=${playerRoleIds.join(",")}`);
    }
    else if (playerRoleId) {
        params.push(`player-role-id=${playerRoleId}`);
    }
    if (evoIds?.length)
        params.push(`included-evolutions=${evoIds.join(",")}`);
    if (mustIncludeEvoIds?.length)
        params.push(`must-include-evolutions=${mustIncludeEvoIds.join(",")}`);
    if (searchText)
        params.push(`search=${searchText}`);
    if (priceMin)
        params.push(`priceMin=${priceMin}`);
    if (priceMax)
        params.push(`priceMax=${priceMax}`);
    if (ratingMin)
        params.push(`ratingMin=${ratingMin}`);
    if (ratingMax)
        params.push(`ratingMax=${ratingMax}`);
    if (pastAndPresentClubs)
        params.push("pastAndPresentClubs");
    if (countries?.length)
        params.push(`country=${countries.join(",")}`);
    if (clubs?.length)
        params.push(`club=${clubs.join(",")}`);
    if (leagues?.length)
        params.push(`league=${leagues.join(",")}`);
    if (rarities?.length)
        params.push(`rarity=${rarities.join(",")}`);
    if (skillMoves?.length)
        params.push(`skill-moves=${skillMoves.join(",")}`);
    if (weakFoot?.length)
        params.push(`weak-foot=${weakFoot.join(",")}`);
    if (preferredFoot)
        params.push(`preferredFoot=${preferredFoot}`);
    if (heightMin)
        params.push(`heightMin=${heightMin}`);
    if (heightMax)
        params.push(`heightMax=${heightMax}`);
    if (playStyles?.length)
        params.push(`playStyles=${playStyles.join(",")}`);
    if (playStylesPlus?.length)
        params.push(`playStylesPlus=${playStylesPlus.join(",")}`);
    if (bodyTypes?.length)
        params.push(`body-types=${bodyTypes.join(",")}`);
    if (gender)
        params.push(`gender=${gender}`);
    if (positions?.length)
        params.push(`position=${positions.join(",")}`);
    /*
      One param per bound, named after the attribute: `paceMin=70&paceMax=90`.
      This is the shape web has always sent; the mobile side was stubbed out
      with a `.join()` over an object, which would have thrown had it ever run,
      so the filter reached this function and was silently dropped.
    */
    for (const [key, range] of Object.entries(inGameAttributes ?? {})) {
        if (range?.min !== undefined)
            params.push(`${key}Min=${range.min}`);
        if (range?.max !== undefined)
            params.push(`${key}Max=${range.max}`);
    }
    queryParams?.forEach((element) => {
        const elementAsObject = Object.entries(element);
        const key = elementAsObject[0]?.[0];
        const values = elementAsObject[0]?.[1];
        if (values.length > 0) {
            params.push(`${queryParamDict[key] || key}=${values.join(",")}`);
        }
    });
    const queryString = params.join("&");
    // console.log("params", params, queryString);
    const res = await axios.get(`/players${evolutions ? "/evolutions" : ""}?v2&${queryString}`);
    const { players, totalPages } = res.data;
    const playersRes = players.map((player) => ({
        ...player,
        positions: Array.from(new Set([player.preferredPosition, ...player.possiblePositions])),
        isSbcPlayer: player.isSbc,
        isObjectivePlayer: player.isObjective,
    }));
    return { players: playersRes, totalPages };
};
//# sourceMappingURL=getPlayers.js.map